import type {FC} from 'react';
import {memo} from 'react';

import IconUserSVG from '@yourcoach/shared/assets/icons/user.svg';

interface Props {
  customClass?: string;
  height?: string;
  viewBox?: string;
  width?: string;
}

const IconUser: FC<Props> = ({
  customClass = '',
  height = '100%',
  viewBox = '0 0 24 24',
  width = '100%',
}) => {
  return (
    <IconUserSVG
      className={`${customClass}`}
      fill="#819AA9"
      height={width}
      viewBox={viewBox}
      width={height}
    />
  );
};

export default memo(IconUser);
